import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-basic-card-clickable',
  templateUrl: './basic-card-clickable.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class BasicCardClickableComponent {
  disabled = input<boolean>(false);
  cssClass = input<string>('');
  ariaLabel = input<string>('');
  readonly cardClicked = output<MouseEvent>();

  onCardClick(event: MouseEvent) {
    if (this.disabled()) {
      return;
    }
    this.cardClicked.emit(event);
  }
}
